module.exports = __webpack_public_path__ + "img/ic-chevron-right.4d0fd1a5.svg";